export const colors = {
  green: '#1ea672',
  pink: '#7B4A99',
  grey: '#b3b3b3'
};

export const links = {
  landing: process.env.GATSBY_STAGE === 'dev' ? 'https://monei-dev.com' : 'https://monei.com',
  dashboard: 'https://dashboard.monei.com',
  signUp: 'https://dashboard.monei.com/?action=signUp',
  api: 'https://docs.monei.com/apis/rest/',
  docs: 'https://docs.monei.com',
  gettingStarted: 'https://docs.monei.com/getting-started/',
  contactSupport: 'mailto:support@monei.com',
  contactSales: 'https://monei.com/contact-sales/',
  facebook: 'https://www.facebook.com/GETMONEI',
  instagram: 'https://www.instagram.com/moneipayments',
  linkedin: 'https://www.linkedin.com/company/monei-digital-payments',
  github: 'https://github.com/MONEI/',
  eurm: 'https://wallet.eurm.org',
  supportUrl: 'https://docs.monei.com/contact-support/',
  pinpointApi:
    process.env.GATSBY_STAGE === 'dev'
      ? 'https://pinpoint.monei-dev.com/'
      : 'https://pinpoint.monei.com/',
  connectApi:
    process.env.GATSBY_STAGE === 'dev'
      ? 'https://connect.monei-dev.com'
      : 'https://connect.monei.com',
  // Free Verification of Payee checker. The endpoint holds the daily limit, the
  // reCAPTCHA check and the MONEI API key; see `src/utils/vopApi.ts` for the contract.
  vopApi:
    process.env.GATSBY_STAGE === 'dev'
      ? 'https://connect.monei-dev.com/vop'
      : 'https://connect.monei.com/vop',
  vopDocs: 'https://docs.monei.com/fraud-prevention/verification-of-payee/',
  // Public receipt page. Self-redirects to the merchant's custom domain, so the
  // payment id alone is enough to link a requester back to their receipt.
  receiptBase:
    process.env.GATSBY_STAGE === 'dev' ? 'https://secure.monei-dev.com' : 'https://secure.monei.com'
};

export const supportDocsUrl = (language?: string): string =>
  language === 'es'
    ? 'https://docs.monei.com/es/onboarding/overview/'
    : 'https://docs.monei.com/onboarding/overview/';

export const configVars = {
  gtmId: 'GTM-NHS56QJ',
  recaptchaSiteKey: '6LejBMYUAAAAAIqU0f3BtAMzBqy70HIIbUuKjqvT',
  measurementId: process.env.GATSBY_STAGE === 'dev' ? 'G-3P1JQLMQKG' : 'G-3P1JQLMQKG'
};
